import React, { Component } from 'react';

import CheckboxSection from "./CheckboxSection";
import ConfiguracionAvanzadaActiveDirectory from "./ConfiguracionAvanzadaActiveDirectory";

const ModoActiveDirectory = (props) => {
    return (
        <div className="row">
            <div className="">

                <CheckboxSection message="Vincular Perfiles con Grupo de Windows"
                    isChecked={props.vincularGrupoWindows}
                    identifier="vincularGrupoWindows"
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}/>

                {(props.vincularGrupoWindows) ? 
                    (<div className="left-separator-xs"> <CheckboxSection message="Permitir el alta del usuario en GyF de forma automática"
                        isChecked={props.altaAutomatica}
                        identifier="altaAutomatica"
                        checkboxChangeState={props.checkboxChangeState}
                        textChangeState={props.textChangeState}/> </div>) : (<div></div>)}

                <p>La administración de sesiones por medio de Active Directory permite por defecto que el usuario logueado en Windows ingrese a los sistemas “G&F” con sus credenciales del sistema operativo. Puede modificar la forma de iniciar sesión en la Configuración avanzada."</p>

                <ConfiguracionAvanzadaActiveDirectory
                    soloUsuarioLoggeado={props.soloUsuarioLoggeado}
                    solicitarContrasenia={props.solicitarContrasenia}
                    checkboxChangeState={props.checkboxChangeState}
                    radioButtonChange={props.radioButtonChange}
                    textChangeState={props.textChangeState}/>   
            </div>
        </div>
    );
};

export default ModoActiveDirectory;